// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styles_bannerContainer__6QkRE","bannerItem":"styles_bannerItem__+BpnF"};